import { registerPlugin } from '@capacitor/core'

const PermissionsPlugin = registerPlugin<PermissionsPlugin>(
    'PermissionsPlugin',
    {}
)
export interface PermissionsPlugin {
    requestCalendarPermissions(): Promise<PermissionStatus>
}

export { PermissionsPlugin }
